export {default} from "./ProTip";
